import { ConfigService, ApiConfigService } from '@nextgen-web-framework/core';
import { useSession } from '../Session/SessionProvider';
import { userProfileRegistry } from './registries';
import { AuthenticatedSession } from './types/propTypes';

const TealiumScript = () => {
  const publicRuntimeConfig = ConfigService.getConfigs();

  return (
    <>
      <script
        data-testid="tealium-script"
        dangerouslySetInnerHTML={{
          __html: `
            //   local property to support utag_data updation in SPA
              window.analytics_prev_prop = [];

              // Tealium override to suppress initial page load
              window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
              window.utag_cfg_ovrd.noview = true;
              

              // Tealium integration script
              (function(a,b,c,d) {
                a='https://tags.tiqcdn.com/utag/${publicRuntimeConfig?.NEXT_PUBLIC_TEALIUM_ACCOUNT}/${publicRuntimeConfig?.NEXT_PUBLIC_TEALIUM_PROFILE}/${publicRuntimeConfig?.NEXT_PUBLIC_TEALIUM_ENVIRONMENT}/utag.js';
                b=document;
                c="script";
                d=b.createElement(c);
                d.src=a;
                d.type="text/java"+c;
                d.async=true;
                a=b.getElementsByTagName(c)[0];
                a.parentNode.insertBefore(d,a);
              })();
              `,
        }}
      />
    </>
  );
};

export const useTealiumDataLayer = (): object => {
  const config = ConfigService.getConfigs();
  const tuples = ApiConfigService.getTuples();
  const { session, isAnonymous } = useSession();
  const obj: AuthenticatedSession = {};
  if (!isAnonymous()) {
    obj['visitor_imcID'] = (config.NEXT_PUBLIC_TENANT as number) * 100000000000 + Number(session.aboNum ?? 0);
    obj['visitor_partyID'] = Number(session.partyId ?? 0);
  }
  return {
    site_country: tuples['X-Amway-Country'],
    site_currencyCode: config.NEXT_PUBLIC_CURRENCY,
    site_language: tuples['Accept-Language']?.split('-')[0],
    visitor_userProfile: userProfileRegistry[session.type ?? 'guest'],
    ...obj,
  };
};
export default TealiumScript;
